import { str } from "./content-helpers";
import type { BlockDocNode } from "./define-block-kind";
import {
	plainTextToPresentationRichText,
	presentationRichTextToPlainText,
	presentationRichTextToTiptapContent,
	readBlockPresentationRichText,
	tiptapDocToPresentationRichText,
} from "./rich-text";

/** A kind rendered by its own node view in the doc (P7). */
export const ATOM_BLOCK_DOC_NODE: BlockDocNode = { mode: "atom" };

/**
 * A kind whose `content` / `richText` body is edited inline in the doc (P7). The body is the rich
 * text when present, else the plain text as paragraphs, as TipTap JSON; an edited body (TipTap
 * JSON) is sanitized to presentation rich text and stored as both `richText` and its plain
 * `content`, through the kind's normalize.
 */
export function richTextBlockDocNode(
	normalizeContent: (raw: Record<string, unknown>) => Record<string, unknown>,
): BlockDocNode {
	return {
		mode: "text",
		toDoc: (content) =>
			presentationRichTextToTiptapContent(
				(
					readBlockPresentationRichText(content) ??
					plainTextToPresentationRichText(str(content.content))
				).content ?? [],
			),
		fromDoc: (previous, body) => {
			const richText = tiptapDocToPresentationRichText({
				type: "doc",
				content: body,
			});
			return normalizeContent({
				...previous,
				content: presentationRichTextToPlainText(richText).trim(),
				richText,
			});
		},
	};
}
